import type { Category } from '../types';

interface CategoryOverviewItem {
  id: Category;
  label: string;
  emoji: string;
  matchCount: number;
  totalQuestions: number;
}

interface CategoryOverviewProps {
  categories: CategoryOverviewItem[];
  onCategoryClick: (category: Category) => void;
}

export default function CategoryOverview({ categories, onCategoryClick }: CategoryOverviewProps) {
  const withPct = categories
    .filter((c) => c.matchCount > 0 && c.totalQuestions > 0)
    .map((c) => ({ ...c, pct: c.matchCount / c.totalQuestions }))
    .sort((a, b) => b.pct - a.pct);

  if (withPct.length === 0) return null;

  const maxPct = withPct[0]!.pct;

  return (
    <div className="space-y-2 py-3">
      {withPct.map((cat, index) => {
        const barWidth = Math.round((cat.pct / maxPct) * 100);
        const badge =
          index === 0
            ? {
                text: '🔥 YOUR HOTSPOT',
                kind: 'hotspot',
                className:
                  'text-[10px] font-bold tracking-widest bg-primary/10 text-primary-400 rounded-full px-2 py-0.5',
              }
            : index === 1
              ? {
                  text: '🌶️ RISING HEAT',
                  kind: 'rising-heat',
                  className:
                    'text-[10px] font-bold tracking-widest bg-accent/10 text-accent-400 rounded-full px-2 py-0.5',
                }
              : null;

        return (
          <button
            key={cat.id}
            onClick={() => onCategoryClick(cat.id)}
            className="flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left transition-colors hover:bg-white/[0.03]"
          >
            <span className="text-2xl leading-none">{cat.emoji}</span>
            <span className="flex flex-1 flex-col gap-1.5">
              <span className="flex items-center justify-between">
                <span className="text-sm font-medium text-white">{cat.label}</span>
                {badge && (
                  <span className={badge.className} data-category-badge={badge.kind}>
                    {badge.text}
                  </span>
                )}
              </span>
              <span className="h-2 w-full rounded-full bg-white/[0.06]">
                <span
                  className="block h-2 rounded-full"
                  style={{
                    width: `${barWidth}%`,
                    background: 'linear-gradient(135deg, #FF3366, #FF8C42)',
                  }}
                />
              </span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
